import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireSocialMediaType} from '../umpire-social-media-type';

export interface UmpireComponentSocialMedia
  extends UmpireComponent<UmpireComponentTypeEnum.SOCIAL_MEDIA> {
  description: string;
  external_url: string;
  social_media_type: UmpireSocialMediaType;
}
